import { useQuery } from '@tanstack/react-query';
import { auth } from '@core/utils/firebase/firebase';
import type { Auth } from '@angular/fire/auth';
import { createAuthApi, type UserProfile } from '../api/auth.api';

const api = createAuthApi(auth as unknown as Auth);

export function useCurrentUserQuery(options?: { enabled?: boolean }) {
  return useQuery<UserProfile | null>({
    queryKey: ['currentUser', auth?.currentUser?.uid || null],
    queryFn: async () => {
      const uid = auth?.currentUser?.uid;
      if (!uid) return null;
      const user: UserProfile = await api.getUserByFirebaseUid(uid);
      return user;
    },
    enabled: Boolean(auth?.currentUser?.uid) && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
  });
}
